<template>
  <div>
    <b-tabs
      nav-class="font-weight-bold package-offer-modal-tabs"
      content-class="mt-3"
    >
      <b-tab
        v-for="(offerTab, offerTabIndex) in offerGroupTypes"
        :key="offerTabIndex"
        :title="offerTab.ogt_type_name"
        @click="handleOfferTabChange(offerTab.ogt_id)"
      >
        <div class="applicable-offer-wrapper">
          <ul
            v-if="getOffersCollection && getOffersCollection.length > 0"
            class="applicable-offers-list list-unstyled"
          >
            <li
              class
              v-for="(OffersItem, OffersIndex) in getOffersCollection"
              :key="OffersIndex"
              style="padding: 7px 7px 30px 7px"
            >
              <div
                name="applicableOffers"
                class="d-flex align-items-center justify-content-between"
              >
                <div
                  class="w-75"
                  v-bind:class="langName == 'ar' ? 'text-right' : ''"
                >
                  <strong style="color:#000">{{
                    // OffersItem.offer_title || OffersItem.offer_code
                    getBothLangOfferName(OffersItem) ||
                      OffersItem.offer_title ||
                      OffersItem.offer_code
                  }}</strong>
                  <!-- <br /> -->
                  <!-- <div
                    class="fs-11 ellipse_class"
                    v-html="getNewOfferDescBothLangHTML(OffersItem)"
                  ></div> -->
                </div>

                <div class="d-flex align-items-center">
                  <div
                    v-b-toggle="'offer-details-123' + OffersIndex"
                    class="btn details_btn"
                  >
                    <strong> {{ allLanguageData.DETAILS }}</strong>
                  </div>
                  <b-button
                    @click="onclickApplyOffer(OffersItem)"
                    class="btn offer-apply-btn"
                  >
                    {{ allLanguageData.APPLY }}
                  </b-button>
                </div>
              </div>

              <b-collapse :id="'offer-details-123' + OffersIndex">
                <div
                  v-html="getOfferDescHTML(OffersItem)"
                  class="details_data"
                ></div>
              </b-collapse>
            </li>
          </ul>
          <ul v-else>
            <li>
              <div>No Offers Found</div>
            </li>
          </ul>
        </div>
      </b-tab>
    </b-tabs>

    <!-- <b-modal no-close-on-esc no-close-on-backdrop hide-header :id="refId" :ref="refId" title="Select Offer">
        </b-modal> -->
  </div>
</template>
<script>
import Vue from "vue";
import VueRouter from "vue-router";
export default {
  name: "OfferModal",
  props: {
    type: {
      type: String,
      default: 1,
    },
    getOffersCollection: {
      type: Array,
      default: [],
    },
    fnb_items: {
      type: Array,
      default: [],
    },
    refId: {
      type: String,
      default: "OfferPopup",
    },
    cust_id: {
      type: Number,
      default: null,
    },
    offerGroupTypes: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      offersData: [],
      ApplicableOfferSelected: false,
    };
  },
  mounted: function() {},
  methods: {
    handleOfferTabChange(offerGroupTypeId) {
      console.log({ offerGroupTypeId });
      this.$emit("handleOfferTabChange", offerGroupTypeId);
    },
    getBothLangOfferName(offer) {
      let offerTitle = ``;
      let offerArr = [];
      let LangId = this.langName == `ar` ? 3 : 1;
      if (offer.hasOwnProperty("offerContent") && offer.offerContent.length) {
        offerArr = offer.offerContent.filter(
          (x) => x.content_lang_id == LangId
        );
        offerTitle = offerArr.length ? offerArr[0].offer_title : "";
      }
      return offerTitle;
    },
    getOfferDescHTML(offer) {
      let offerDesc = ``;
      let offerDescArr = [];
      let LangId = this.langName == `ar` ? 3 : 1;
      if (offer.hasOwnProperty("offerContent") && offer.offerContent.length) {
        offerDescArr = offer.offerContent.filter(
          (x) => x.content_lang_id == LangId
        );
        offerDesc = offerDescArr.length
          ? offerDescArr[0].offer_description
          : "";
      }
      return offerDesc;
    },
    getNewOfferDescBothLangHTML(offer) {
      let offerDesc = ``;
      let offerDescArr = [];
      let LangId = this.langName == `ar` ? 3 : 1;
      if (offer.hasOwnProperty("offerContent") && offer.offerContent.length) {
        offerDescArr = offer.offerContent.filter(
          (x) => x.content_lang_id == LangId
        );
        offerDesc = offerDescArr.length
          ? offerDescArr[0].offer_description
          : "";
      }
      const splitOfferContent = offerDesc.split(/<\/p><p>/);

      splitOfferContent[0] = splitOfferContent[0].replace(/^<p>/, "");
      splitOfferContent[splitOfferContent.length - 1] = splitOfferContent[
        splitOfferContent.length - 1
      ].replace(/<\/p>$/, "");

      // console.log(splitOfferContent[0]);
      return splitOfferContent[0];
    },
    getOfferDescription(offer, moreInfo = false) {
      let text = ``;
      if (offer.offer_type_id == 9) {
        if (moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || "";
          if (offerCondition) {
            text += `Max Apply limit ${offerCondition}`;
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket @ ${
            offer.oc_discount_value
          } Each.`;
          let FNB_Criteria = [];
          if (offer.oc_is_combo_with_fnb == "Y" && offer.fnb_group_data) {
            try {
              FNB_Criteria = offer.fnb_group_data
                ? JSON.parse(offer.fnb_group_data)
                : [];
            } catch (err) {
              console.log("Error", err);
              FNB_Criteria = offer.fnb_group_data ? offer.fnb_group_data : [];
            }
            if (FNB_Criteria.length > 0) {
              text +=
                " Also Get" +
                FNB_Criteria.map(
                  (y) =>
                    y.oc_buy_no_of_item +
                    "x -" +
                    y.selectedFnbItem.item_name +
                    " @ " +
                    this.currFormat(y.oc_fnb_at_price) +
                    " Each."
                ).join(", ");
            }
          }
        }
        return text;
      } else if (offer.offer_type_id == 10) {
        if (moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || "";
          if (offerCondition) {
            text += `Max Apply limit ${offerCondition}`;
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket and Get ${
            offer.oc_discount_value_is_percentage == "Y" ? "" : "Flat"
          } ${offer.oc_discount_value} ${
            offer.oc_discount_value_is_percentage == "Y" ? "%" : ""
          } OFF on another ticket.`;
          return text;
        }
      } else if (offer.offer_type_id == 11) {
        text = `Get discount on valid fnb products`;
        return text;
      }
    },
    onclickApplyOffer(offerObj) {
      // console.log({ offerObj });
      this.$emit("onApplyOffer", offerObj);
    },
  },
};
</script>
<style scoped>
.offer-apply-btn {
  background-color: #cc202e;
  width: 75%;
  padding: 5px 15px;
  border: 1px solid transparent;
  border-radius: 25px;
  font-size: 25px;
}
.details_btn {
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/OfferModal.vue